export default "__VITE_ASSET__DwErNGdu__"